import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
//stores
import useAdminStore from "src/webapp/stores/admin.store";
//CompWrapper
import Section from 'src/webapp/views/wrapper/Section';
import Container from 'src/webapp/views/wrapper/Container';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
import ActiveButtonWrapper from 'src/webapp/views/wrapper/ActiveButtonWrapper';
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
//Comp
import Menu from 'src/webapp/views/component/Menu';//메뉴
import Titlebar from 'src/webapp/views/component/Titlebar';//상단타이틀
import BrandList from './List';//제조사별차량리스트
import BrandAdd from './popup/BrandAdd';//제조사추가팝업
import BrandUpdate from './popup/BrandUpdate';//제조사추가수정\

export default function MemberList() {
    //stores
    const { admin } = useAdminStore();
    //팝업오픈여부
    const itemRef = useRef({});
    const [ isOpen,setOpen ] = useState({add:false, update:false});
    const onDismissHandler = (name, value, item, isLoad) => {
        if(value && item !== null) { itemRef.current = item; }
        setOpen((prevState) => {
            return { ...prevState, [name]:value }
        })
        if(isLoad) { childRef.current.brandListAPI(true, true); }//리스트데이터리로드
    }
    //브랜드선택핸들러
    const childRef = useRef({});
    //선택브랜드삭제핸들러
    const brandOnDeleteHanelr = () => {
        childRef.current.brandDeleteAPI();
    }

    return ( 
        <>
        <Section>
            <Menu />{/* 메뉴 */}
            <Container>
                <FixedPanel>
                    <Titlebar title={`차량 데이터 관리`}  dept={[{label:'기타'}, {label:'차량 데이터 관리'}, {label:'제조사 관리'}]} />{/* 상단타이틀 */}
                </FixedPanel>
                <FixedPanel>
                    <ActiveButtonWrapper>
                        <Element tag={`div`} >
                            <Link to={'/brand/item/list'}><Element tag={`span`}>차량 관리</Element></Link>
                            {admin.LEVEL <= 1 ? <button onClick={(e) => onDismissHandler('add', true, null, false)}><span>제조사 추가</span></button> : null}
                        </Element>
                        <Element tag={`div`} >
                            {admin.LEVEL <= 2 ? <button onClick={(e) => brandOnDeleteHanelr()} className="btnDelete"><span>선택 삭제</span></button> : null}
                        </Element>
                    </ActiveButtonWrapper>
                </FixedPanel>
                <FlickPanel>
                    <BrandList ref={childRef} onDismiss={onDismissHandler} />
                </FlickPanel>
            </Container>
        </Section>
        {isOpen.add ? <BrandAdd isOpen={isOpen.add} data={null} onDismiss={onDismissHandler} /> : null}
        {isOpen.update ? <BrandUpdate isOpen={isOpen.update} data={itemRef} onDismiss={onDismissHandler} /> : null}
        </>
    );
}